import { PrintItemDialogController } from "./print-item-dialog.controller";

class PrintItemService {

    public static $inject: string[] = [
        "$mdDialog"
    ];

    private $mdDialog;

    constructor(
        $mdDialog
    ) {
        this.$mdDialog = $mdDialog;
    }

    public print(item) {
        this.$mdDialog.show({
            controller: PrintItemDialogController,
            controllerAs: "printItemDialogCtrl",
            hasBackdrop: false,
            template: require("./print-item-dialog.html"),
            locals: {
                item: item
            },
            bindToController: true,
            parent: angular.element(document.body),
            onShowing: this._toggleBodyClassName,
            onRemoving: this._toggleBodyClassName
        });
    }

    private _toggleBodyClassName() {
        const body = angular.element(document.body);
        const className = "md-dialog-is-printing";
        if (body[0].className.indexOf(className) !== -1) {
            body.removeClass(className);
        } else {
            body.addClass(className);
        }
    }
}

angular
    .module("thor.shared.print.item.service", [])
    .service("printItemService", PrintItemService);
